import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminPanel } from "./admin";
import TurboPage from "./TurboPage";
import ContactPage from "./ContactPage";
import { BlogListPage, BlogPostPage } from "./BlogPages";

// Layout Components
import { Navbar, Footer, WhatsAppFloating } from "./components/layout";

// Section Components
import {
  HeroSection,
  PackagesSection,
  FlowingTurboSection,
  FeaturesSection,
  CoverageSection,
  AboutSection,
  BlogSection,
  FAQSection,
} from "./components/sections";

// Main Website Component
const MainWebsite = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <PackagesSection />
        <FlowingTurboSection />
        <FeaturesSection />
        <CoverageSection />
        <AboutSection />
        <BlogSection />
        <FAQSection />
      </main>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
};

// App Component with Router
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainWebsite />} />
        <Route path="/turbo" element={<TurboPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:id" element={<BlogPostPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
